import React from "react";
import { object, number, array, string } from "prop-types";
import { Link } from "@quintype/components";
import { connect } from "react-redux";
import get from "lodash/get";

import { getSlug } from "../../utils";

import CardImageType1 from "../../molecules/card-image-type-1";
import CardImageType7 from "../../molecules/card-image-type-7";
import ReadMore from "../../atoms/read-more";
import Headline from "../../atoms/headline";

import "./organism-2.m.css";

class Organism2 extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      collectionIndex: 0
    };
  }

  render() {
    const {
      collectionStories,
      collectionOfCollections,
      collectionName,
      limit = 3,
      headerType = 5,
      headlineLimit,
      totalItems,
      collection,
      href,
      sections
    } = this.props;
    const filteredCollectionOfCollections = collectionOfCollections.filter(item => item.items.length > 0);
    const collectionNameDom = filteredCollectionOfCollections.map((item, index) => {
      const customHeaderType = this.state.collectionIndex === index ? 2 : 4;
      const activeTab = this.state.collectionIndex === index ? "active" : "inactive";

      return (
        <Headline
          active={activeTab}
          text={item.name}
          headerType={customHeaderType}
          headerLevel={3}
          key={index}
          onClick={() => this.setState({ collectionIndex: index })}
        />
      );
    });

    const multipleHeaders = () => <div styleName="header-tabs">{collectionNameDom}</div>;

    const singleCollectionHeader = () => (
      <div styleName="header-tabs">
        <Link href={href}>
          <Headline text={collectionName} headerType={headerType} headerLevel={3} />
        </Link>
      </div>
    );

    const storyCards = (firstStory, renderOtherStories, totalCollectionStories, collection) => {
      const slug = getSlug(collection, sections);

      return (
        <React.Fragment key={collection.id}>
          {firstStory && <CardImageType1 story={firstStory.story} headlineLimit={headlineLimit} widths={[564]} />}
          <div styleName="group-1">{renderOtherStories}</div>
          {!totalCollectionStories && totalItems > 4 && slug && <ReadMore href={slug} />}
          {totalCollectionStories > 4 && slug && <ReadMore href={slug} />}
        </React.Fragment>
      );
    };

    const renderStoriesDom = (stories, index, totalCollectionStories, collection) => {
      let [firstStory, ...restOftheStories] = stories;
      const renderOtherStories = restOftheStories
        .slice(0, limit)
        .map((story, index) => <CardImageType7 story={story.story} key={index} headlineLimit={headlineLimit} />);
      return (
        this.state.collectionIndex === index &&
        storyCards(firstStory, renderOtherStories, totalCollectionStories, collection)
      );
    };

    const childCollectionStories = () =>
      filteredCollectionOfCollections.map((item, index) => {
        const stories = item.items.filter(item => item.type === "story");
        const totalCollectionStories = item.items.length;
        return renderStoriesDom(stories, index, totalCollectionStories, item);
      });

    const singleCollectionStories = () => renderStoriesDom(collectionStories, 0, totalItems, collection);

    const organism2Dom = () => {
      if (collectionOfCollections.length > 0 && filteredCollectionOfCollections.length > 0) {
        return (
          <div className="bg-wrapper">
            {multipleHeaders()}
            {childCollectionStories()}
          </div>
        );
      } else if (collectionStories.length > 0) {
        return (
          <div className="bg-wrapper">
            {singleCollectionHeader()}
            {singleCollectionStories()}
          </div>
        );
      } else {
        return null;
      }
    };

    return organism2Dom();
  }
}

const mapStateToProps = state => {
  return {
    sections: get(state, ["qt", "config", "sections"], [])
  };
};

Organism2.propTypes = {
  collection: object,
  limit: number,
  headerType: number,
  headlineLimit: number,
  collectionStories: array,
  collectionOfCollections: array,
  collectionName: string,
  totalItems: number,
  href: string,
  sections: array
};

export default connect(
  mapStateToProps,
  null
)(Organism2);
